export const CLIENT_HEALTHCHECK_ROUTE = '/healthcheck'
export const PORTFOLIO_CLIENT_HEALTHCHECK_ROUTE = '/portfolio/healthcheck'

export function clientHomeRoute(hasPortfolioAccess: boolean): string {
  return hasPortfolioAccess ? PORTFOLIO_CLIENT_HEALTHCHECK_ROUTE : CLIENT_HEALTHCHECK_ROUTE
}

export function isClientAllowedPath(pathname: string): boolean {
  return (
    pathname.startsWith('/healthcheck') ||
    pathname.startsWith('/portfolio/healthcheck') ||
    pathname.startsWith('/profile') ||
    pathname.startsWith('/help') ||
    pathname.startsWith('/sign-out') ||
    pathname.startsWith('/twofa')
  )
}
